<ul ngbNav #nav="ngbNav" class="nav-pills pt-3">
  @for(key of utilService.objectKeys(packageService.packages); track $index) {

    <li ngbNavItem>
      <button ngbNavLink>
        {{ getTitle(key) }}
        @if(
          packageService.packages[key].length &&
          getTitle(key) != 'Entregados'
        ) {
          <span class="badge text-bg-secondary">
            {{ packageService.packages[key].length || 0 }}
          </span>
        }
      </button>
      <ng-template ngbNavContent>

        <div class="container-fluid">
          <div class="row pt-3">

            @if(getTitle(key) == 'Entregados') {
              
              <app-packages-list
                [packages]="packageService.packages[key]"
                [neighborhoodId]="neighborhoodId"
                [pickupDate]="true">
              </app-packages-list>

            } @else {

              <app-packages-list
                [packages]="packageService.packages[key]"
                [neighborhoodId]="neighborhoodId">
              </app-packages-list>

            }

          </div>
        </div>

      </ng-template>
    </li>

  }
</ul>
<div [ngbNavOutlet]="nav"></div>